// Copyright 2024 Vajra. All rights reserved.
// Users Page

export default function UsersPage() {
  return (
    <div>
      <h1 className="text-2xl font-semibold text-gray-900">Users</h1>
      <p className="mt-2 text-sm text-gray-700">
        Manage users and their access permissions.
      </p>
      {/* User list would go here */}
    </div>
  );
}
